'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowRight, FeatherCheck, FeatherMail, FeatherMessageCircle, FeatherSend, FeatherSparkles } from '@subframe/core';
import React, { useState } from 'react';
import { ProdutoModal } from './ProdutoModal';
import type { ProdutoKey } from '../types/produtoModalTypes';
interface ProdutoCardProps {
  title: string;
  description: string;
  illustration: React.ReactNode;
  onClick: () => void;
}
function ProdutoCard(t0) {
  const $ = _c(16);
  const {
    title,
    description,
    illustration,
    onClick
  } = t0;
  let t1;
  if ($[0] !== illustration) {
    t1 = <div className="relative h-32 w-full shrink-0 overflow-hidden">{illustration}</div>;
    $[0] = illustration;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <span className="text-default-font text-sm font-medium">{title}</span>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FeatherArrowRight className="h-4 w-4 text-neutral-400 transition-colors group-hover:text-neutral-600" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="flex items-center justify-between">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== description) {
    t5 = <span className="text-subtext-color text-xs leading-5">{description}</span>;
    $[7] = description;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex flex-1 flex-col justify-between p-4"><div className="flex flex-col gap-2">{t4}{t5}</div></div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onClick || $[13] !== t1 || $[14] !== t6) {
    t7 = <button type="button" onClick={onClick} className="group hover:border-brand-200 relative flex min-w-0 cursor-pointer flex-col overflow-hidden rounded-[16px] border border-solid border-neutral-200 bg-white text-left shadow-sm transition-all hover:shadow-md">{t1}{t6}</button>;
    $[12] = onClick;
    $[13] = t1;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function EtapaRow(t0) {
  const $ = _c(14);
  const {
    largura,
    prazo,
    estado
  } = t0;
  const concluida = estado === "concluida";
  let t1;
  if ($[0] !== concluida) {
    t1 = concluida ? <span className="bg-brand-600 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full"><FeatherCheck className="h-2.5 w-2.5 text-white" /></span> : <span className="border-brand-400 hp-node-pulse flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full border-2 bg-white"><span className="bg-brand-400 h-1.5 w-1.5 rounded-full" /></span>;
    $[0] = concluida;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `h-1.5 rounded-full ${concluida ? "bg-brand-100" : "bg-neutral-100"}`;
  let t3;
  if ($[2] !== largura) {
    t3 = {
      width: largura
    };
    $[2] = largura;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="flex-1"><div className={t2} style={t3} /></div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `text-[9px] font-semibold ${concluida ? "text-brand-600" : "text-neutral-400"}`;
  let t6;
  if ($[7] !== prazo || $[8] !== t5) {
    t6 = <span className={t5}>{prazo}</span>;
    $[7] = prazo;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t4 || $[12] !== t6) {
    t7 = <div className="flex items-center gap-2.5">{t1}{t4}{t6}</div>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function ReguaIllustration() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="hp-dots hp-dots-brand" />;
    t1 = <span className="bg-brand-600 absolute top-3 left-3 z-20 flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold text-white">Novo</span>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-brand-50 relative flex h-full w-full items-center justify-center">{t0}{t1}<div className="border-brand-100 hp-float relative z-10 flex w-[85%] flex-col gap-0 rounded-[8px] border border-solid bg-white px-3.5 py-3 shadow-md"><EtapaRow largura="70%" prazo="D+0" estado="concluida" /><div className="bg-brand-100 ml-2 h-3 w-0.5" /><EtapaRow largura="55%" prazo="D+7" estado="concluida" /><div className="bg-brand-100 ml-2 h-3 w-0.5" /><EtapaRow largura="45%" prazo="D+15" estado="atual" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function CanalChip(t0) {
  const $ = _c(6);
  const {
    className,
    delay,
    children
  } = t0;
  const t1 = `hp-float absolute z-10 flex h-7 w-7 items-center justify-center rounded-full shadow-md ${className}`;
  let t2;
  if ($[0] !== delay) {
    t2 = {
      animationDelay: delay
    };
    $[0] = delay;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t1 || $[4] !== t2) {
    t3 = <div className={t1} style={t2}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function AgentesIllustration() {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="hp-dots hp-dots-success" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CanalChip className="bg-success-500 top-4 left-5 text-white" delay="0s"><FeatherMessageCircle className="h-[15px] w-[15px]" /></CanalChip>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CanalChip className="bg-information-color-support-info-600 top-5 right-5 text-white" delay="0.5s"><FeatherSend className="h-[15px] w-[15px]" /></CanalChip>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CanalChip className="text-subtext-color right-8 bottom-5 bg-white" delay="1s"><FeatherMail className="h-[15px] w-[15px]" /></CanalChip>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="from-brand-400 to-brand-800 hp-orb-pulse flex h-8 w-8 flex-none items-center justify-center rounded-full bg-gradient-to-br"><FeatherSparkles className="h-4 w-4 text-white" /></span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="text-brand-600 text-[11px] font-semibold">Lexi</span>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="bg-brand-400 hp-typing h-1.5 w-1.5 rounded-full" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="bg-brand-400 hp-typing h-1.5 w-1.5 rounded-full" style={{
      animationDelay: "0.2s"
    }} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="bg-success-50 relative flex h-full w-full items-center justify-center">{t0}{t1}{t2}{t3}<div className="border-brand-100 hp-float relative z-20 flex w-[80%] items-center gap-2.5 rounded-xl border border-solid bg-white px-3.5 py-3 shadow-lg">{t4}<div className="flex min-w-0 flex-1 flex-col gap-1.5">{t5}<div className="flex items-center gap-1">{t6}{t7}<span className="bg-brand-400 hp-typing h-1.5 w-1.5 rounded-full" style={{
              animationDelay: "0.4s"
            }} /></div></div></div></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}
function NotificacaoIllustration() {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="hp-dots hp-dots-neutral" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="hp-sweep pointer-events-none absolute top-0 left-0 h-full w-[35%]" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-1.5"><span className="bg-coral-500 h-2.5 w-2.5 flex-none rounded-[2px]" /><div className="h-[5px] w-1/2 rounded-full bg-neutral-800" /></div>;
    t3 = <div className="h-1 w-[92%] rounded-full bg-neutral-200" />;
    t4 = <div className="h-1 w-full rounded-full bg-neutral-200" />;
    t5 = <div className="h-1 w-[85%] rounded-full bg-neutral-200" />;
    t6 = <div className="h-1 w-[96%] rounded-full bg-neutral-200" />;
    t7 = <div className="h-1 w-[60%] rounded-full bg-neutral-200" />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="hp-float relative z-10 flex w-[60%] flex-col gap-[7px] overflow-hidden rounded-md border border-solid border-neutral-200 bg-white px-3.5 pt-3.5 pb-5 shadow-lg">{t1}{t2}{t3}{t4}{t5}{t6}{t7}<span className="border-coral-500 text-coral-500 absolute right-3 bottom-3 flex h-[30px] w-[30px] rotate-[-14deg] items-center justify-center rounded-full border-2"><FeatherCheck className="h-3.5 w-3.5" /></span></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="relative flex h-full w-full items-center justify-center overflow-hidden bg-neutral-100">{t0}{t8}<div className="hp-float absolute top-5 right-[18px] z-20 flex items-center gap-1.5 rounded-full border border-solid border-neutral-200 bg-white px-2.5 py-1 shadow-md"><FeatherSend className="text-brand-600 h-3 w-3" /><span className="text-brand-600 text-[11px] font-semibold">Enviada</span></div></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}
export function ProdutosDestaque() {
  const $ = _c(6);
  const [modalKey, setModalKey] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ProdutoCard title={"R\xE9gua de cobran\xE7a"} description={"Automatize lembretes e etapas de cobran\xE7a."} illustration={<ReguaIllustration />} onClick={() => setModalKey("regua")} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ProdutoCard title="Agentes de IA" description="A Lexi conversa e negocia nos seus canais." illustration={<AgentesIllustration />} onClick={() => setModalKey("agentes")} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">{t0}{t1}<ProdutoCard title={"Notifica\xE7\xE3o extrajudicial"} description="Envie avisos formais a devedores." illustration={<NotificacaoIllustration />} onClick={() => setModalKey("notificacao")} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setModalKey(null);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== modalKey) {
    t4 = <>{t2}<ProdutoModal produtoKey={modalKey} onClose={t3} /></>;
    $[4] = modalKey;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}